import { Route, Routes } from 'react-router-dom';

import { SidebarLayout } from '../layouts/SidebarLayout';
import Account from '../pages/Account';
import { NotFound } from '../pages/errors/NotFound';
import { ClientRoute } from './clientRoute';

export const AccountRoute = () => {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <ClientRoute>
                        <SidebarLayout>
                            <Account />
                        </SidebarLayout>
                    </ClientRoute>
                }
            />
            {/* 404 - Catch all unmatched routes */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
